export default "__VITE_ASSET__LHnSrbSP__"